import { Typography } from '@design-system/components/typography/typography';
import { ReactNode } from 'react';

import programGroupImage from '/static/images/program-group.png';

import * as styles from './ProgramsEmptyState.css';

type ProgramsEmptyStateProps = {
  createMenu: ReactNode;
};

export const ProgramsEmptyState = ({ createMenu }: ProgramsEmptyStateProps) => {
  return (
    <div className={styles.container} data-testid="programs-empty-state">
      <div className={styles.card}>
        <div className={styles.copy}>
          <Typography variant="headline" size="small">
            No programs yet
          </Typography>
          <Typography
            variant="body"
            size="medium"
            fontWeight="normal"
            className={styles.subtitle}
          >
            Create your first program or category to start building your
            products.
          </Typography>
          <div>{createMenu}</div>
        </div>
        <img
          src={programGroupImage}
          alt="Programs empty state"
          className={styles.image}
        />
      </div>
    </div>
  );
};
